import { render, staticRenderFns } from "./RequestDetailsTabResponses.vue?vue&type=template&id=522f26f2"
import script from "./RequestDetailsTabResponses.vue?vue&type=script&lang=js"
export * from "./RequestDetailsTabResponses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports